import { Injectable } from "@angular/core";
import { Api } from "../api/api";

import { Observable } from "rxjs/Observable";

@Injectable()
export class DeviceProvider {
  url: string = "devices/current";

  constructor(public api: Api) {}

  putAdvertisingId(id: string): Observable<any> {
    return this.api.put(this.url, {
      advertising_id: id
    });
  }

  putAdjustId(id: string): Observable<any> {
    return this.api.put(this.url, {
      adjust_device_id: id
    });
  }

  putToken(token: string): Observable<any> {
    return this.api.put(this.url, {
      push_token: token
    });
  }

  putApnsToken(token: string): Observable<any> {
    return this.api.put(this.url, {
      apns_push_token: token
    });
  }

  inactive(): Observable<any> {
    return this.api.delete(this.url + "/activeness");
  }
}



// WEBPACK FOOTER //
// ./src/providers/device/device.ts